// extracted by mini-css-extract-plugin
module.exports = {"link":"OrderStatusLink_link__OucXc","icon":"OrderStatusLink_icon__B2gK3"};